<script setup lang="ts">
  import { useMediaQuery } from '@vueuse/core'

  import { VgsDrawerColorScheme } from '@/enums/VgsDrawerColorScheme'
  
  import { KsDrawer } from '@aschehoug/kloss'
  
  const props = withDefaults(
    defineProps<{
      title?: string
      colorScheme?: VgsDrawerColorScheme
    }>(),
    {
      colorScheme: VgsDrawerColorScheme.Black,
      title: ''
    }
  )

  const isMobile = useMediaQuery('(max-width: 767px)')
</script>

<template>
  <KsDrawer
    :class="['vgs-drawer', `vgs-drawer-${props.colorScheme}`]"
    v-bind="props"
    :backdrop="false"
    :size="isMobile ? '100vw' : '40vw'"
  >
    <template #body>
      <slot />
    </template>
  </KsDrawer>
</template>

<style lang="scss">
  // width: 100% < 768px;
  .vgs-drawer {
    --ks-roundness: 0;

    background: var(--background-color-drawer);
    color: var(--color-drawer);
    overflow-x: hidden;
    padding: 8vh 5vw 40px;

    @include vgs-media-mobile {
      padding: 80px 24px;
    }

    &-black {
      --background-color-drawer: var(--color-black);
      --color-drawer: var(--color-yellow-10);
    }

    &-blue {
      --background-color-drawer: var(color-lightblue-10);
      --color-drawer: var(--color-blue-50);
    }

    &-orange {
      --background-color-drawer: var(--color-orange-20);
      --color-drawer: var(--color-blue-50);
    }

    &-violet {
      --background-color-drawer: var(--color-violet-20);
      --color-drawer: var(--color-red-40);
    }

    .cms-h:first-of-type {
      margin-top: 0;
    }

    .cms-a {
      color: var(--color-drawer);
      overflow-wrap: break-word;

      &::after {
        background-color: var(--color-drawer);
      }
    }

    &__wrapper {
      position: relative;
    }

    .ks-dialog-backdrop {
      width: 40vw;
    }

    .ks-dialog-header {
      display: unset;
      padding: 0;

      .ks-button {
        color: var(--color-drawer);
        position: fixed;
        top: 24px;
        left: 24px;

        @include vgs-media-mobile {
          top: 16px;
          left: 16px;
        }
      }

      .ks-truncate {
        font-size: 1.75rem;
        font-weight: 600;
        line-height: 150%;
        margin-bottom: 8px;
        white-space: initial;
      }
    }

    .ks-dialog-body {
      height: unset;
      padding: 0;

      .longform-text {
        margin: 0;
        padding: 0;
      }

      .text-image-element {
        background: unset;
        min-height: unset;
        justify-content: flex-start;
        padding: unset;

        .app-layout {
          padding: 0;
        }

        .app-layout-fullwidth {
          margin: 0;
        }

        .wrapper {
          align-items: unset;
          gap: 64px;
          padding: 0;
          flex-direction: column;

          .text,
          .image {
            align-self: unset;
            color: var(--color-drawer);
          }

          .image {
            background-color: var(--color-white);
          }
        }
      }
    }
  }
</style>
